/**
 *
 * @class AuthenticationManager
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/manager/AuthenticationManager.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */
import RouteRequirements from "../../model/RouteRequirements";

export class RouteRequirementsManager {
    constructor(store, router) {
        this._store = store;
        this._router = router;
    }

    /**
     *
     * @param routeRequirements RouteRequirements
     * returns object for redirect if route is not allowed, otherwise null
     */
    check(routeRequirements = null) {
        if (!routeRequirements) {
            routeRequirements = new RouteRequirements();
        }

        if (routeRequirements.isRequireLogin() && !this._store.state.authToken) {
            return {name: 'Login'};
        }

        if (routeRequirements.getEnabledModules() !== null) {
            const enabledModules = routeRequirements.getEnabledModules();
            for (let i=0; i<enabledModules.length; i++) {
                if (!this._store.getters['enabledModules/getIsModuleEnabled'](enabledModules[i])) {
                    return { name: 'Alerts' };
                }
            }
        }

        if (routeRequirements.getRequiresPatient() && !this._store.getters['patientSummary/id']) {
            return { name: 'Alerts' };
        }

        if (routeRequirements.getAllowedVisits() !== null) {
            const currentVisit = this._store.getters['patientSummary/currentVersion'];

            if (!currentVisit || !routeRequirements.getAllowedVisits().includes(currentVisit/1)) {
                return {name: 'Alerts'};
            }
        }

        const customChecks = routeRequirements.getCustomChecks();

        for (let i=0; i<customChecks.length; i++) {
            const result = customChecks[i](this._store, this._router);
            if (result) {
                return result;
            }
        }

        return null;
    }

    isAllowed(routeRequirements = null) {
        return this.check(routeRequirements) === null;
    }
}